import React from 'react';
import { Route, IndexRoute } from 'react-router';
import { lazify } from '../Common/Helper';
import { willRequireLogin } from '../Auth';
/* eslint-disable */
import WithCreateTaopixProjectIntoCart from 'split-chunk-loader?lazy!../Common/Providers/WithCreateTaopixProjectIntoCart';
/* eslint-enable */

const Routes = (
    <Route
      label=''
      path='createTaopixProject'
    >
      <IndexRoute component={willRequireLogin(lazify(WithCreateTaopixProjectIntoCart))}></IndexRoute>
    </Route>
);

export default Routes;



// WEBPACK FOOTER //
// ./src/Routes/Taopix.js